<template>
  <el-upload
    ref="upload"
    :action="action"
    :headers="uploadHeader"
    :show-file-list="true"
    :on-success="onSuccess"
    :on-error="onError"
    :on-exceed="onExceed"
    :on-remove="onRemove"
    list-type="picture-card"
    :file-list="fileList"
    accept="video/*"
    :multiple="true"
    :limit="limit"
    :class="size"
    :before-upload="beforeUpload"
  >
    <i slot="default" class="el-icon-plus"></i>
    <div slot="file" slot-scope="{ file }">
      <video
        :src="file.response ? file.response.data : file.url"
        style="width: 80px; height: 80px; padding: 8px"
        poster="../assets/images/video-poster.png"
      ></video>

      <span
        class="el-upload-list__item-actions"
        style="display: flex; justify-content: center; align-items: center"
      >
        <span class="el-upload-list__item-delete">
          <VideoPlayer
            :nobg="true"
            :srcs="[`${file.response ? file.response.data : file.url}`]"
          ></VideoPlayer>
        </span>
        <span
          class="el-upload-list__item-delete"
          style="margin-left: 0"
          @click="handleRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </div>
  </el-upload>
</template>

<script>
import { urlPerfix } from '@/config/env'
import store from '@/store/index'
import videoPlayer from './videoPlayer.vue'

export default {
  components: { videoPlayer },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 9,
    },
    size: String,
  },
  data() {
    return {
      action: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      fileList: [],
    }
  },
  watch: {
    value(val) {
      if (val.length == 0) {
        this.fileList = val
      }
    },
  },
  created() {
    let fileList = this.value
    if (this.value.some((item) => typeof item === 'string')) {
      fileList = this.value.map((item, index) => ({
        name: 'img' + index + 1,
        url: item,
      }))
    }
    this.fileList = fileList
  },
  methods: {
    onSuccess(response, file, fileList) {
      this.onFileChange(fileList)
    },

    onFileChange(fileList) {
      let fileArray = fileList.map((item) => {
        return item.url.includes('blob') ? item.response.data : item.url
      })
      this.$emit('input', fileArray)
    },

    onError(err, file, fileList) {
      console.log(err)
    },

    onExceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}个文件`)
    },

    onRemove(file, fileList) {
      this.onFileChange(fileList)
    },

    handleRemove(file) {
      const files = this.$refs.upload.uploadFiles
      let index = files.findIndex((item) => item.uid === file.uid)
      if (index >= 0) {
        files.splice(index, 1)
      }
      this.onFileChange(files)
    },

    beforeUpload(file) {
      const isLimitSize = file.size / 1024 / 1024 <= this.uploadLimitSize.file
      if (!isLimitSize) {
        this.$message.error(
          `文件：${file.name} 上传失败，文件大小不能超过${this.uploadLimitSize.file}MB!`
        )
      }
      return isLimitSize
    },
  },
}
</script>